import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom';
import LoginPage from './pages/login_page';
import LogPage from './pages/log_page';
import DashboardPage from './pages/dashboard_page';
import ReportsPage from './pages/reports_page';
import PaymentsPage from './pages/payments_page';
import AccessControlPage from './pages/access_control_page';
import OrdersPage from './pages/orders_page';
import FormPage from './pages/form_page';
import ProfitPage from './pages/profit_page';
import PotentialPage from './pages/potential_page';
import LoadFilePage from './pages/load_file_page';
import PageContainer from './components/page_container';
import RefreshSessionButton from './components/refresh_session_button';
import OpenRevPage from './pages/open_rev_page'
import OpenProfitPage from './pages/open_profit_page'
import StaffPage from './pages/staff_page';
import MopsPage from './pages/mops_page';
import PDZPage from './pages/pdz_page';
import OrderSuppliersPage from './pages/order_suppliers_page';
import OverdueReceivablesPage from './pages/overdue_receivables_page';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import { observer } from 'mobx-react-lite';
import { clearAuthSession, ensureAuthenticated } from './auth/auth';
// Перед открытием защищённой страницы восстанавливаем JWT (в т.ч. в новой вкладке по URL).
async function requireAuth() {
  const authenticated = await ensureAuthenticated();
  if (!authenticated) {
    clearAuthSession();
    return redirect('/');
  }
  return null;
}
const authRoute = (path, Page) => ({
  path,
  loader: requireAuth,
  element: (
    <PageContainer>
      <Page />
    </PageContainer>
  ),
});
// BrowserRouter читает URL браузера (нужно для новых вкладок и Ctrl+клик в header)
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PageContainer>
        <LoginPage />
      </PageContainer>
    ),
  },
  authRoute("/dashboard", DashboardPage),
  authRoute("/reports", ReportsPage),
  authRoute("/openRev", OpenRevPage),
  authRoute("/openProfit", OpenProfitPage),
  authRoute("/postoplat", PaymentsPage),
  authRoute("/debitor", OrdersPage),
  authRoute("/managerForm", FormPage),
  authRoute("/profit", ProfitPage),
  authRoute("/uploadProfit", LoadFilePage),
  authRoute("/staff", StaffPage),
  authRoute("/mops", MopsPage),
  authRoute("/rights", AccessControlPage),
  authRoute("/potential", PotentialPage),
  authRoute("/pdz", PDZPage),
  authRoute("/logs", LogPage),
  authRoute("/orderSuppliers", OrderSuppliersPage),
  authRoute("/overdue", OverdueReceivablesPage),
  {
    path: "*",
    loader: async () => {
      const authenticated = await ensureAuthenticated();
      return redirect(authenticated ? "/openProfit" : "/");
    },
  },
]);
const App = observer(() => {
  return (
    <ChakraProvider theme={theme}>
      <RouterProvider router={router} />
      {/* Выше роутера: loader защищённого маршрута может не завершиться,
          и тогда страница не отрисуется — а кнопка нужна именно в этот момент. */}
      <RefreshSessionButton />
    </ChakraProvider>
  );
})
export default App;
